import React, { Component } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import {
  soporteEnviar,
  soporteObtenerPreguntasKnowledgeBase,
} from '../../store/actions';
import { Regex, RegexExtra, Validate } from '../../other';
import {
  Card,
  CardContent,
  Grid,
  Typography,
  withStyles,
} from '@material-ui/core';
import {
  AutosuggestUI,
  InputUI,
  ButtonUI,
  AlertUI,
  ModuleTitleUI,
  ModuleButtonBoxUI,
  NextActionsUI,
  ToggleUI,
  CardModuleUI,
} from '../common';
import { PreguntasList } from './subcomponents';
import { WrapperLayout } from '../../layouts/WrapperLayout';

class Soporte_ extends Component {
  state = {
    after: false,
    next_message: '',
    soporte: {
      so_mensaje: {
        auth: false,
        validate: true,
        required: true,
        disabled: false,
        error: false,
        type: 'text',
        label: 'Mensaje',
        id: 'so_mensaje',
        name: 'so_mensaje',
        change_param: 'soporte',
        regex: Regex.DESCRIPCION_20_5000,
        value: '',
        default_value: '',
        placeholder: 'Escriba su mensaje aquí',
        messages: {
          error: 'Por favor, ingrese un mensaje válido',
          error_extra: RegexExtra.DESCRIPCION_20_5000,
        },
      },
    },
    filter: {
      search: {
        auth: false,
        validate: false,
        required: true,
        disabled: false,
        error: false,
        type: 'text',
        label: 'Buscar',
        id: 'search',
        name: 'search',
        change_param: 'filter',
        regex: Regex.ANYTHING,
        value: '',
        default_value: '',
        placeholder: 'Tengo una consulta sobre...',
        messages: {
          error: '',
          error_extra: RegexExtra.ANYTHING,
        },
      },
    },
    loading: {
      soporte: true,
      error: false,
    },
    forms: {
      soporte: false,
    },
    alert: {
      open: false,
      type: 'error',
      message: '',
    },
    feed: [],
    feed_input_value: '',
    selected_option: '',
    articles_arr: [],
  };

  //autosuggest
  debounceMethod = null;

  componentDidMount() {
    this.props.soporteObtenerPreguntasKnowledgeBase((err, resp) => {
      this.setState(
        {
          loading: {
            ...this.state.loading,
            soporte: false,
            error: err ? true : false,
          },
        },
        () => {
          let articles_arr = [];
          resp.data.knowledge_base_data.forEach((category) => {
            category.subcategories.forEach((subcategory) => {
              subcategory.articles.forEach((article) => {
                articles_arr = [
                  ...articles_arr,
                  {
                    ...article,
                    subcategory: subcategory.title,
                    subcategory_slug: subcategory.slug,
                    category: category.title,
                    category_slug: category.slug,
                    rank: 0,
                  },
                ];
              });
            });
          });
          this.setState({ articles_arr: articles_arr });
        }
      );
    });

    this.debounceMethod = debounce(this.handleSuggestionFetchData, 200);
  }

  normalizeText = (value) => {
    value = value.toLowerCase();
    value = value.replaceAll('á', 'a');
    value = value.replaceAll('é', 'e');
    value = value.replaceAll('í', 'i');
    value = value.replaceAll('ó', 'o');
    value = value.replaceAll('ú', 'u');
    value = value.replaceAll('ñ', 'n');

    return value;
  };

  handleSuggestionFetchData = (value) => {
    if (value.length > 1) {
      let words = value.split(' ');

      let array = [...this.state.articles_arr];
      words.forEach((word) => {
        word = this.normalizeText(word);
        array.forEach((article) => {
          let title_art = this.normalizeText(article.title);
          let category = this.normalizeText(article.category);
          let subcategory = this.normalizeText(article.subcategory);
          let content;
          if (article.type === 0) {
            content = this.normalizeText(article.content);
            if (content.includes(word)) article.rank = article.rank + 1;
          }

          if (title_art.includes(word)) article.rank = article.rank + 1;
          if (category.includes(word)) article.rank = article.rank + 1;
          if (subcategory.includes(word)) article.rank = article.rank + 1;
        });
      });

      array.sort((a, b) => {
        return b.rank - a.rank;
      });

      let feed = array.filter((element) => element.rank > 0);
      feed = feed.slice(0, 15);

      this.setState({ feed: feed });
    }
  };

  handleChangeFilter = (e, blur, aditional) => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState({
      [aditional]: {
        ...this.state[aditional],
        [name]: {
          ...this.state[aditional][name],
          value: value,
        },
      },
    });
  };

  handleChange = (e, blur, aditional) => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState(
      {
        [aditional]: {
          ...this.state[aditional],
          [name]: {
            ...this.state[aditional][name],
            value: value,
          },
        },
      },
      () => {
        Validate.validate_input(this.state[aditional][name], blur, (input) => {
          this.setState({
            [aditional]: {
              ...this.state[aditional],
              [name]: input,
            },
          });
        });
      }
    );
  };

  handleCloseAlert = () => {
    this.setState({
      alert: {
        ...this.state.alert,
        open: false,
      },
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({
      forms: {
        ...this.state.forms,
        soporte: true,
      },
    });

    let form = this.state.soporte;

    if (Validate.validar_formulario(form)) {
      this.props.soporteEnviar(
        {
          so_mensaje: form.so_mensaje.value,
        },
        (err, resp) => {
          this.setState({
            forms: {
              ...this.state.forms,
              soporte: false,
            },
            after: err ? false : true,
            next_message: err ? '' : resp.message,
            alert: {
              ...this.state.alert,
              open: true,
              message: resp.message,
              type: err ? 'error' : 'success',
            },
          });
        }
      );
    } else {
      Validate.validar_formulario_actualizar_obj(form, (new_form) => {
        this.setState({
          forms: {
            ...this.state.forms,
            soporte: false,
          },
          soporte: new_form,
        });
      });
    }
  };

  handleOnSuggestionSelected = (selected_suggestion) => {
    this.setState(
      {
        selected_option: selected_suggestion,
        feed_input_value: '',
      },
      () => {
        if (selected_suggestion.type === 0) {
          this.props.history.push(
            `/soporte/${selected_suggestion.category_slug}/${selected_suggestion.subcategory_slug}/${selected_suggestion.slug}`
          );
        } else {
          window.open(selected_suggestion.content, '_blank');
        }
      }
    );
  };

  handleSuggestionsFetchRequested = ({ value }) => this.debounceMethod(value);

  handleSuggestionsClearRequested = () => {
    let articles = [...this.state.articles_arr];
    articles.forEach((article) => {
      article.rank = 0;
    });

    this.setState({
      feed: [],
      articles_arr: articles,
    });
  };

  handleSuggestionsChangeSelected = (e, { newValue }) =>
    this.setState({ feed_input_value: newValue });

  render() {
    let classes = this.props.classes;

    return (
      <WrapperLayout
        loading={this.state.loading.soporte}
        error={this.state.loading.error}
      >
        <AlertUI
          open={this.state.alert.open}
          message={this.state.alert.message}
          type={this.state.alert.type}
          handleCloseAlert={this.handleCloseAlert}
        />
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <Typography className={classes.title}>
              Acá podés encontrar lo que necesitás
            </Typography>
            <div className={classes.search}>
              <CardModuleUI>
                <Grid container justify="space-between" spacing={24}>
                  <Grid item xs={12}>
                    <AutosuggestUI
                      suggestions={this.state.feed}
                      input_value={this.state.feed_input_value}
                      suggestion_selected={this.state.selected_option}
                      suggestion_index={'title'}
                      label={'Buscar'}
                      placeholder={'Tengo una consulta sobre...'}
                      handleOnSuggestionSelected={
                        this.handleOnSuggestionSelected
                      }
                      handleSuggestionsFetchRequested={
                        this.handleSuggestionsFetchRequested
                      }
                      handleSuggestionsClearRequested={
                        this.handleSuggestionsClearRequested
                      }
                      handleSuggestionsChangeSelected={
                        this.handleSuggestionsChangeSelected
                      }
                    />
                  </Grid>
                </Grid>
              </CardModuleUI>
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <Typography className={classes.title}>
              Preguntas frecuentes sobre...
            </Typography>
            <Card className={classes.card_below}>
              <CardContent className={classes.card_content_questions}>
                <PreguntasList
                  preguntas={this.props.preguntas.knowledge_base_data}
                  filtro={this.state.filter.search}
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <Typography className={classes.title}>
              ¿Necesitas ayuda? Escribinos
            </Typography>
            <ModuleTitleUI
              subtitles={[
                'Si tienes dudas, sugerencias o simplemente necesitas ayuda con tu tienda, no dudes en contactarnos.',
                'Responderemos tu consultas en 24hs hábiles a tu correo electrónico.',
              ]}
            />
            <ToggleUI show={!this.state.after}>
              <form onSubmit={this.handleSubmit}>
                <Card className={classes.card}>
                  <CardContent className={classes.card_content}>
                    <Grid container spacing={24}>
                      <Grid item xs={12}>
                        <InputUI
                          handleChange={this.handleChange}
                          multiline
                          input={this.state.soporte.so_mensaje}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                <ModuleButtonBoxUI>
                  <ButtonUI
                    type="submit"
                    label="ENVIAR"
                    isLoading={this.state.forms.soporte}
                  />
                </ModuleButtonBoxUI>
              </form>
            </ToggleUI>
            <ToggleUI show={this.state.after}>
              <Card className={classes.card}>
                <CardContent className={classes.card_content}>
                  <Grid container spacing={24}>
                    <Grid item xs={12}>
                      <NextActionsUI
                        title={this.state.next_message}
                        buttons={[]}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </ToggleUI>
          </Grid>
        </Grid>
      </WrapperLayout>
    );
  }
}

const styles = (theme) => ({
  card: theme.card.card,
  card_below: theme.card.card_below,
  card_content_questions: {
    padding: 0,
    '&:last-child': {
      padding: 0,
    },
  },
  title: {
    color: theme.texts.module_title,
    margin: '10px 0px',
    fontSize: '1rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '1.3rem',
    },
  },
  search: {
    marginTop: '20px',
  },
});

const mapStateToProps = (state) => {
  return {
    preguntas: state.preguntasKnowledgeBase,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    soporteEnviar: (data, callback) => dispatch(soporteEnviar(data, callback)),
    soporteObtenerPreguntasKnowledgeBase: (callback) =>
      dispatch(soporteObtenerPreguntasKnowledgeBase(callback)),
  };
};

export const Soporte = withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Soporte_)
);
